import { render, staticRenderFns } from "./DrugReview.vue?vue&type=template&id=29865246&scoped=true"
import script from "./DrugReview.vue?vue&type=script&lang=js"
export * from "./DrugReview.vue?vue&type=script&lang=js"
import style0 from "./DrugReview.vue?vue&type=style&index=0&id=29865246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29865246",
  null
  
)

export default component.exports